/**
 * 실험 #368 - /match/request 상조 광고 유입 랜딩 A/B.
 *
 * 모수: 아래 광고그룹으로 들어온 광고 유입.
 *  - 네이버: n_ad_group (네이버 검색광고가 자동으로 붙이는 광고그룹 id)
 *  - 구글: utm_adgroup (구글 광고 최종 URL 접미사에 `utm_adgroup={adgroupid}` 로 싣는다)
 *  - A = 기존 /match/request 퍼널(MatchRequestInitialQuestionContainer)
 *  - B = 상조 랜딩(SangjoLandingContainer)
 *
 * 두 팔 모두 상단 sub-nav 를 유지하고 긴급전화 배너 실험을 얹지 않는다.
 * 팔 간 차이를 "랜딩 vs 기존 퍼널" 하나로 묶기 위해서다.
 *
 * ?template=sangjo 는 실험과 무관하게 랜딩을 고정 노출한다(QA·마케팅 링크용).
 */
export const SANGJO_LANDING_EXPERIMENT_KEY = 368;

/** 실험 대상 네이버 광고그룹 id */
const NAVER_AD_GROUP_IDS = ["grp-a001-01-000000075625201"];

/** 구글 광고 최종 URL 에 광고그룹 id 를 싣는 파라미터 이름 */
const GOOGLE_AD_GROUP_PARAM = "utm_adgroup";

/** 실험 대상 구글 광고그룹 id */
const GOOGLE_AD_GROUP_IDS = ["207126695408", "207126695448"];

const pickString = (value: unknown) => (typeof value === "string" ? value : "");

/**
 * 실험 #368 모수 여부. Header(sub-nav)와 MatchRequestContainer 가 같은 판정을 쓴다.
 * @param query router.query
 */
export const isSangjoLandingAdTarget = (query: Record<string, unknown>): boolean => {
  if (NAVER_AD_GROUP_IDS.includes(pickString(query.n_ad_group))) return true;

  if (GOOGLE_AD_GROUP_PARAM) {
    return GOOGLE_AD_GROUP_IDS.includes(pickString(query[GOOGLE_AD_GROUP_PARAM]));
  }

  return false;
};
